import React from 'react'

export const Star = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill={props.fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_34_6593)'>
      <path
        d='M12.5212 17.3183C12.2012 17.1229 11.7988 17.1229 11.4788 17.3183L8.17368 19.3369C7.41459 19.8005 6.47338 19.1167 6.67974 18.2515L7.57829 14.4841C7.66528 14.1194 7.54091 13.7366 7.25612 13.4927L4.3161 10.9742C3.64054 10.3956 4.00011 9.28901 4.8868 9.21798L8.74608 8.90878C9.11991 8.87883 9.44555 8.64224 9.58956 8.29597L11.0767 4.72019C11.4182 3.89885 12.5817 3.89885 12.9233 4.72019L14.4104 8.29597C14.5544 8.64224 14.8801 8.87883 15.2539 8.90878L19.1138 9.21797C20.0006 9.28901 20.3601 10.3957 19.6845 10.9743L16.7439 13.4927C16.4591 13.7366 16.3347 14.1194 16.4217 14.4842L17.3202 18.2515C17.5266 19.1167 16.5854 19.8005 15.8263 19.3369L12.5212 17.3183Z'
        fill={props.fill || 'currentColor'}
      />
    </g>
    <defs>
      <clipPath id='clip0_34_6593'>
        <rect width='24' height='24' fill='currentColor' />
      </clipPath>
    </defs>
  </svg>
)
